import gql from 'graphql-tag';
import { DEAL_BUILDER_ENTITY_FRAGMENT } from './fragments/dealBuilderEntity.fragment';

export const GET_ACTIVE_DEAL_BUILDER = gql`
  query GetActiveDealBuilder($vendorOpportunityId: ID!) {
    dealBuilder {
      getActiveDealBuilder(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          ...DealBuilderEntityFields
        }
      }
    }
  }
  ${DEAL_BUILDER_ENTITY_FRAGMENT}
`;
